module.exports = __webpack_public_path__ + "img/flujos.2476e569.gif";